import { render } from "./ProjectRoadmapChart.vue?vue&type=template&id=19c5e824&ts=true"
import script from "./ProjectRoadmapChart.vue?vue&type=script&lang=ts"
export * from "./ProjectRoadmapChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__